module.exports = __webpack_public_path__ + "fontawesome-webfont.25a32416abee198dd821.eot";


//////////////////
// WEBPACK FOOTER
// /Users/diego/Documents/SirisWebSite/WebSite/src/assets/fonts/fontawesome-webfont.eot
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.eot
// module chunks = styles